import { LoginAddressType, ProfileTier } from '@fcom/core-api/login';

export interface MailingAddressData {
  city: string;
  companyName?: string;
  country: string;
  postalCode: string;
  primary: boolean;
  stateOrProvince: string;
  buildingNameOrPrefecture: string;
  streetAddress: string;
  type: LoginAddressType;
}

export interface MailingAddressSubmissionData {
  countryCode: string;
  addresses: MailingAddressData[];
}

export enum PersonalInformationFormFields {
  DATE_OF_BIRTH = 'dateOfBirth',
  EMAIL = 'email',
  COUNTRY_CODE = 'countryCode',
  NATIONAL_NUMBER = 'nationalNumber',
  MOBILE_PHONE = 'mobilePhone',
  GENDER = 'gender',
}

export interface TravelProfileSubmissionData {
  householdSize?: number;
  childrenBirthYears?: string[];
  topicsOfInterest?: string[];
  travelProfile: {
    seatPreference?: string;
    mealPreference?: string;
  };
}

export enum TravelProfileFormField {
  HOUSEHOLD_SIZE = 'householdSize',
  CHILDREN_BIRTH_YEARS = 'childrenBirthYears',
  TOPICS_OF_INTEREST = 'topicsOfInterest',
  SEAT_PREF = 'seatPreference',
  MEAL_PREF = 'mealPreference',
}

export enum SeatPreferenceOption {
  NO_PREFERENCE = 'Remove',
  AISLE = 'Aisle',
  WINDOW = 'Window',
}

export enum MealPreferenceOption {
  NO_PREFERENCE = 'Remove',
  BLML = 'BLML',
  DBML = 'DBML',
  GFML = 'GFML',
  LCML = 'LCML',
  LFML = 'LFML',
  LSML = 'LSML',
  NLML = 'NLML',
  HNML = 'HNML',
  AVML = 'AVML',
  KSML = 'KSML',
  MOML = 'MOML',
  CHML = 'CHML',
  FPML = 'FPML',
  VGML = 'VGML',
  VLML = 'VLML',
  VJML = 'VJML',
  SPML = 'SPML',
}

export enum TopicOfInterest {
  FOD = 'FOD',
  SPE = 'SPE',
  MUE = 'MUE',
  BEF = 'BEF',
  HOD = 'HOD',
  BUL = 'BUL',
  HEW = 'HEW',
  HOT = 'HOT',
  CAR = 'CAR',
  CIH = 'CIH',
  BEH = 'BEH',
  SPH = 'SPH',
  ACH = 'ACH',
  TOH = 'TOH',
  CRU = 'CRU',
  ENR = 'ENR',
}

export enum MailingAddressFormField {
  BUILDING_NAME_OR_PREFECTURE = 'buildingNameOrPrefecture',
  CITY = 'city',
  COMPANY_NAME = 'companyName',
  COUNTRY = 'country',
  POSTAL_CODE = 'postalCode',
  PRIMARY = 'primary',
  STATE_OR_PROVINCE = 'stateOrProvince',
  STREET_ADDRESS = 'streetAddress',
  ADDRESS_TYPE = 'addressType',
}

export enum MarketingPreferencesFormField {
  PREFERRED_LANGUAGE = 'preferredLanguage',
  RECEIVE_ALL_EMAILS = 'receiveAllEmails',
  RECEIVE_PARTNER_PROMOTIONS = 'receivePartnerPromotions',
  RECEIVE_SMS_PROMOS = 'receiveSmsPromos',
  RECEIVE_MAIL_WEEKLY_OFFERS = 'receiveMailWeeklyOffers',
}

export enum PassportInformationFormFields {
  NUMBER = 'passportNumber',
  EXPIRY_DATE = 'passportExpirationDate',
  ISSUE_DATE = 'passportIssueDate',
  COUNTRY = 'passportCountry',
}

export interface MarketingLanguageSubmissionData {
  marketingLanguage: string;
}

export interface PersonalInformationSubmissionData {
  email: string;
  phoneNumber: string;
  gender: string;
  dateOfBirth?: string;
}
export interface PassportInformationSubmissionData {
  travelProfile: {
    passportInformation: {
      passportNumber: string;
      passportIssueDate: string;
      passportExpirationDate: string;
      passportCountry: string;
    };
  };
}

export interface GuardianInformationSubmissionData {
  guardianName: string;
  guardianPhoneNumber: string;
  guardianEmail: string;
  guardianMemberNumber: string;
}

export interface UpdateProfileResponseData {
  status: {
    message: string;
  };
}

export interface UpdateToPlusSubmissionData {
  memberTier: ProfileTier.BASIC;
}

export type UpdateProfileSubmissionData =
  | MailingAddressSubmissionData
  | MarketingLanguageSubmissionData
  | PersonalInformationSubmissionData
  | PassportInformationSubmissionData
  | GuardianInformationSubmissionData
  | TravelProfileSubmissionData
  | UpdateToPlusSubmissionData;
